import moment from 'moment';

export const generateFGLTicket = (label, client, customer) => {
    let section;
    let row;
    let seat;
    let stubSection;

    let dateShort = moment(label.event_date.event_datetime_local.substring(0, 19)).format('ddd, MMM Do YYYY @ h:mm a');
    let dateLong = moment(label.event_date.event_datetime_local.substring(0, 19)).format('LLLL').toString();

    let SectionRowSeat = label.full_seat_name.split(':');
    if (label.venue.venue_type === 'general-admission') {
        section = ``;
        row = `General Admission: `;
        seat = `${SectionRowSeat[2]}`;
        stubSection =`General Admission`;
    } else {
        section = `Section: ${SectionRowSeat[0]} `;
        row = `Row: ${SectionRowSeat[1]} `;
        seat = `Seat: ${SectionRowSeat[2]}`;
        stubSection = section + ' ' + row;
    }

    let dateStub2 = dateShort.split('@')[1].trim();
    let fullAddress = label.venue.address.trim() + ', ' + label.venue.city.trim() + ', ' + label.venue.state.trim() + ', ' + label.venue.zip;
    const eventName = label.event.name.substring(0, 70);
    const eventNameTag = label.event.name.length <= 35 ? '<HW2,2>' : '<HW2,1>';
    stubSection = (stubSection.replace(/ +(?= )/g,'').length > 28)
        ? stubSection.replace(/ +(?= )/g,'').substring(0, 28)
        : stubSection.replace(/ +(?= )/g,'');
    const price = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(label.price);

    let venueName = label.venue.name;

    // If event is not an event
    // Tickets - Event Type Customization #1145
    if (label.event.event_type && label.event.event_type !== 'Event') {
        fullAddress = '';
        dateStub2 = '';
        dateShort = '';
        dateLong = '';
        venueName = '';
    }

    let _customer = {
        first_name: customer.first_name,
        last_name: customer.last_name,
    };
    if (label.customer) {
        _customer.first_name = label.customer.first_name;
        _customer.last_name = label.customer.last_name;
    }

    let cmds = `
        <RR>
        <RC30,2280><F3><HW1,1><BS26,44>${stubSection}
        <RC30,2220><F3><HW1,1><BS26,44>${seat}
        <RC30,2160><F3><HW1,1><BS26,44>${dateShort.split('@')[0]}
        <RC30,2100><F3><HW1,1><BS26,44>${dateStub2}
        <RC30,2040><F3><HW1,1><BS26,44>${price}
            
        <RU>
        <RC680,1850><F3><HW1,1><BS26,44>${client.client_name}
        <RC630,1850><F6>${eventNameTag}<BS26,44>${eventName}
        <RC520,1850><F6><HW1,1><BS26,44>${dateLong}
            
        <RC440,1850><F3><HW1,1><BS26,44>${venueName}
        <RC400,1850><F3><HW1,1><BS26,44>${fullAddress}
            
        <RC320,1850><F6><HW1,1><BS26,44>${section}${row}${seat}
            
        <QRV7>
        <RC240,1850><QR4>{${label.id}}
        <RC240,1600><F3><HW1,1><BS26,44>${price}
        <RC200,1600><F3><HW1,1><BS26,44>${label.transaction_id} - ${_customer.first_name} ${_customer.last_name} 
        <p>
    `;
    return cmds;
};

export const generateFGLFlexpass = (label, client) => {
    const flexpassName = label.name.substring(0, 70);
    const flexpassNameTag = label.name.length <= 35 ? '<HW2,2>' : '<HW2,1>';

    let cmds = `
        <RU>
        <RC680,1850><F3><HW1,1><BS26,44>${client.client_name}
        <RC630,1850><F6>${flexpassNameTag}<BS26,44>${flexpassName}
        <RC510,1850><F3><HW1,1><BS26,44>Thank you for purchasing a Flex Pass!
        <RC470,1850><F3><HW1,1><BS26,44>PLEASE BE SURE TO KEEP THIS TICKET.
        <RC410,1850><F3><HW1,1><BS26,44>When you are ready to purchase your individual tickets,
        <RC370,1850><F3><HW1,1><BS26,44>please use the code below during the purchase process.
        <RC310,1850><F3><HW1,1><BS26,44>You do not have to redeem all your tickets at once.
        <RC270,1850><F3><HW1,1><BS26,44>Some events may be restricted from use with Flex Passes.
            
        <RC220,1850><F6><HW1,1><BS26,44>This Flex Pass it worth ${label.max_tickets} tickets.
        <RC150,1850><F6><HW1,1><BS26,44>Code: ${label.code}
        <p>
    `;
    return cmds;
};

export const generateFGLCoupon = (label) => {
    const couponName = label.couponName.substring(0, 70);
    const couponNameTag = label.couponName.length <= 35 ? '<HW2,2>' : '<HW2,1>';
    const couponDescription = label.couponDescription.substring(0, 70);
    const couponDescriptionTag = label.couponDescription.length <= 35 ? '<HW2,2>' : '<HW2,1>';

    let cmds = `
        <RU>
        <RC630,1850><F6>${couponNameTag}<BS26,44>${couponName}
        <RC500,1850><F6>${couponDescriptionTag}<BS26,44>${couponDescription}
        <RC370,1850><F6><HW1,1><BS26,44>${label.code}
        <p>
    `;
    return cmds;
};


// WEBPACK FOOTER //
// ./src/lib/labels/boca/templates.js